import './contactBanner.css'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] } },
}

export default function ContactBanner() {
  return (
    <motion.section
      className="contact-banner"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/salonDeProvence1.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={reveal}
    >
      <div className="overlay"></div>

      <motion.div className="contact-content" variants={reveal}>
        <motion.h1 variants={reveal}>BESOIN DE PLUS D'INFORMATIONS ?</motion.h1>
        <motion.p variants={reveal}>NOUS SOMMES À VOTRE DISPOSITION POUR TOUTE DEMANDE</motion.p>

        <div className="contact-buttons">
          <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.99 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/Contact" className="btn btn-light btn-lg">
              CONTACT
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </motion.section>
  )
}